// extracted by mini-css-extract-plugin
export default {"category":"Category_category__t5ntT","heading":"Category_heading__g1lCM","content":"Category_content__JGcXU","title":"Category_title__6O8+W","cards":"Category_cards__QiH9E"};